<div class="reopen-action-dialog-wrapper">
    <div class="reopen-form-wrapper">
        <div class="filter filter-select">
            <div class="multiselect-filter__container">
                <label class="select-lbl">Reason Category:</label>
                <cv-dropdown
                    [required]="true"
                    [options]="reasonTypes"
                    (valuesChange)="onReasonCategoryChange($event)"
                    [optionText]="'label'"
                    [optionValue]="'key'"
                    [placeholder]="'Select Category'"
                >
                </cv-dropdown>
            </div>
        </div>
        <div class="filter">
            <div class="input-filter__container">
                <label class="text-lbl">Reason:</label>
                <cv-input
                    [required]="true"
                    (controlKeyup)="onReasonChange($event)"
                    [type]="'textarea'"
                    [name]="'reason'"
                    [placeholder]="'Enter a Reason'"
                ></cv-input>
            </div>
        </div>
    </div>
    <hr>
    <div class="footer-button-wrapper">
        <button
            pButton
            type="button"
            class="p-button-primary p-button-outlined p-button-sm"
            (click)="reOpen()"
            [disabled]="isFormInvalid()"
            label="Reopen"
        ></button>
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-outlined p-button-sm"
            (click)="close()"
            label="Close"
        ></button>
    </div>
</div>
